import isNotSafeInteger from 'utils/predicates/number/isNotSafeInteger.util';

const generateIntegers = (options) => {
  if (isNotSafeInteger(options?.bgn)) return [];
  if (isNotSafeInteger(options?.end)) return [];

  const { bgn, end } = options;

  return bgn > end ? Array.from({ length: bgn - end + 1 }, (_, i) => bgn - i) : Array.from({ length: end - bgn + 1 }, (_, i) => bgn + i);
};

export default generateIntegers;
